<template>
	<div class="content">
		<van-nav-bar title="攻略详情" left-text="返回" left-arrow @click-left="onClickLeft" />
		<p class="detail-title">{{guideData.guideSubTitle}}</p>
		<p class="update-date">更新时间:{{guideData.updateDate}}</p>
		<img class="position" src="../assets/image/position.png"/>
		<p class="address">{{guideData.addr}}</p>
		<p class="browse">{{guideData.browse}}</p>
		<van-divider />
		<p class="profile">{{guideData.detail}}</p>
		<div class="spot">
			<p class="spot-title">{{guideData.spotTitle}}</p>
			<p class="spot-content">{{guideData.spotContent}}</p>
			<img class="spot-img" :src="guideData.spotImg"/>
		</div>
	</div>
</template>

<script>
	import {
		useRoute
	} from 'vue-router';
	export default {
		
		setup() {
			const route = useRoute();
			const guideData = JSON.parse(decodeURIComponent(route.query.data));
			return {
				guideData
			}
		},
		

	}
</script>

<style scoped>
	.content{
		position: relative;
	}
	.detail-title{
		font-size: 34px;
		margin-top: 40px;
		margin-left: 50px;
		font-weight: bold;
		display: inline-block;
	}
	.update-date{
		font-size: 28px;
		color: #787878;
		margin-left: 50px;
		margin-top: 20px;
	}
	.position{
		width: 35px;
		height: 35px;
		margin-left: 40px;
		float: left;
		margin-top: 35px;
	}
	.address{
		font-size: 28px;
		display: inline-block;
	}
	.browse{
		font-size: 24px;
		position: absolute;
		right: 20px;
		top: 225px;
		color: #787878;
	}
	.profile{
		font-size: 30px;
		margin-left: 50px;
		margin-right: 50px;
		color: #4b4b4b;
	}
	.spot{
		width: 90%;
		height: 80%;
		margin-left: 5%;
		margin-top: 20px;
		background: #f4f4f4;
	}
	.spot-title{
		font-size: 38px;
		text-align: center;
		padding-top: 20px;
	}
	.spot-content{
		font-size: 30px;
		padding: 20px;
		color: #4b4b4b;
	}
	.spot-img{
		width: 96%;
		margin-left: 2%;
	}
	/deep/.van-nav-bar__content{
		height: 80px;
	}
	/deep/.van-nav-bar__title{
		font-size: 30px;
		line-height: 50px;
	}
	/deep/.van-nav-bar__text{
		font-size: 30px;
	}
</style>
